import Vue from 'vue'
import Vuex from 'vuex'
import Vuetify from 'vuetify'
import vuexI18n from 'vuex-i18n'
import * as localize from './localization'

import AuthStore from './AuthStore'
import TemplateStore from './TemplateStore'
import WorkersStore from './WorkersStore'
import UsersStore from './UsersStore'
import EmployersStore from './EmployersStore'
import LandlordsStore from './LandlordsStore'
import HistoryStore from './HistoryStore'
import ReportsStore from './ReportsStore'
import SettingsStore from './SettingsStore'
import NotifyStore from './NotifyStore'
import AgencyStore from './AgencyStore'
import PersonalFinanceStore from './PersonalFinanceStore'

import config from '../config'
import colors from "vuetify/es5/util/colors"

Vue.use(Vuex)

const store = new Vuex.Store({
	modules: {
		auth: AuthStore,
		templates: TemplateStore,
		workers: WorkersStore,
		users: UsersStore,
		employers: EmployersStore,
		landlords: LandlordsStore,
		history: HistoryStore,
		reports: ReportsStore,
		settings: SettingsStore,
		notifications: NotifyStore,
		agencies: AgencyStore,
		finance: PersonalFinanceStore
	}
})
Vue.use(vuexI18n.plugin, store)

Vue.i18n.add('en', localize.en)
Vue.i18n.add('cz', localize.cz)

Vue.i18n.set(config.locale)

Vue.use(Vuetify, {
	lang: {
		t: (key, ...params) => Vue.i18n.translate(key, params)
	},
	theme: {
		primary: colors.indigo.lighten3
	}
})

export default store
